import styled from 'styled-components';
import PropTypes from 'prop-types';
import H5 from '../H5/H5';
import { Spacings, TextColors } from '../../../styleConstants';
import P1 from '../P1/P1';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 40px;
`;

const Title = styled(H5)`
  margin-bottom: 8px;
`;

const StyledUl = styled.ul`
  list-style: none;
  padding-left: 0px;
`;

const StyledP1 = styled(P1)`
  margin-top: ${Spacings.SPACING_2B};
  color: ${TextColors.BLUE};
`;

const ContentsTable = ({ data }) => {
  return (
    <Container>
      <Title>Table of contents :</Title>
      <StyledUl>
        {data.map((dataItem, index) => {
          const { label, id } = dataItem;
          return (
            <li key={String(index)}>
              <a href={`#${id}`}>
                <StyledP1>{label}</StyledP1>
              </a>
            </li>
          );
        })}
      </StyledUl>
    </Container>
  );
};

ContentsTable.propTypes = {
  data: PropTypes.arrayOf(PropTypes.any).isRequired
};

export default ContentsTable;
